<template>
  <div class="container is-fluid">
    <div class="content content-padding">
      <h1 class="title">Lista de Slides</h1>

      <hr>
      <level-slide v-for="slide of slides" :slide="slide" :slideTotal="slides.length" :parent="parent" :menu="menu"></level-slide>

      <a class="button is-primary" @click="openSlideEditModal">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>Criar</span>
      </a>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import SlideEditModal from './SlideEditModal'
  import LevelSlide from './LevelSlide'

  const SlideEditModalComponent = Vue.extend(SlideEditModal)

  export default {
    components: {
      LevelSlide
    },

    props: {
      slides: Array,
      parent: Number,
      menu: Object
    },

    data () {
      return {
      }
    },

    mounted () {
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      openSlideEditModal () {
        if (this.parent) {
          let openCardModalSubSlide = (propsData = {}) => {
            return new SlideEditModalComponent({
              el: document.createElement('div'),
              propsData
            })
          }

          openCardModalSubSlide({
            title: 'Criar Sub-slide',
            slideTotal: this.slides.length,
            slideData: null,
            menu: this.menu,
            parent: this.parent,
            isSubslide: true
          })
        } else {
          let openCardModalSlide = (propsData = {}) => {
            return new SlideEditModalComponent({
              el: document.createElement('div'),
              propsData
            })
          }

          openCardModalSlide({
            title: 'Criar Slide',
            slideTotal: this.slides.length,
            slideData: null,
            menu: this.menu,
            parent: null,
            isSubslide: false
          })
        }
      }
    },

    watch: {
      currentEvent: function (val) {
      }
    }
  }
</script>

<style lang="scss">
  .color-preview {
    height: 15px;
    width: 15px;
    border: 1px solid black;
    margin-left: 5px;
  }

  .slide-image {
    background-image: url("~assets/images/ps-neutral.png") !important;
  }

  .flexbox-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
</style>


// WEBPACK FOOTER //
// SlideList.vue?32d6412a